<!--
 * @Description: 累计感知路网态势事件数量
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-17 18:07:14
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-04-20 11:29:34
 -->
<template>
  <div class="eventCountContainer">
    <div class="titleHeader">
      <img src="/static/img/layout/arrow-orange.png" alt="">
      <span class="titleName">累计感知路网态势事件数量</span>
    </div>
    <div class="eventCount" ref="eventCount"></div>
  </div>
</template>

<script>
// /screen/lwtsgz/eventBar
export default {
  name: 'eventCount',
  components: {
  },
  data () {
    return {
      charts: '',
      xAxis: '',
      yAxis: '',
    }
  },
  methods: {
    /**
     * @description                   初始化图表
     * @return {undefied}             无返回值
     */
    initCharts () {
      this.charts = this.$echarts.init(this.$refs.eventCount)
      let options = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        xAxis: {
          type: 'category',
          data: this.xAxis,
          nameTextStyle: {
            color: '#fff',
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        yAxis: {
          name: '事件数量（件）',
          type: 'value',
          nameTextStyle: {
            color: '#fff',
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#32444B',
              type: 'dashed',
            },
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
            },
          },
        },
        series: [{
          itemStyle: {
            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
              offset: 0,
              color: 'rgba(3,247,247,0.9)',
            }, {
              offset: 0.3,
              color: 'rgba(3,247,247,0.9)',
            }, {
              offset: 1,
              color: 'rgba(20,51,56,0.9)',
            }]),
            borderRadius: [4, 4, 0, 0],
          },
          barWidth: 7,
          data: this.yAxis,
          type: 'bar',
        }],
      }
      this.charts.setOption(options)
      window.onresize = () => {
        this.charts.resize()
      }
    },
    /**
     * @description                   获取图表数据
     * @return {undefied}             无返回值
     */
    getChartsData () {
      this.$http.get('/rest/screen/lwtsgz/eventBar')
        .then(res => {
          if (res.code === 0) {
            this.xAxis = res.data.xAxis
            this.yAxis = res.data.yAxis
            this.initCharts()
          } else {
            this.$message({
              message: res.msg,
              type: 'error',
            })
          }
        })
    },
  },
  mounted () {
    this.getChartsData()
  },
  created () {
  },
}
</script>

<style lang="less" scoped>
  .eventCountContainer {
    width: 100%;
    height: 100%;
    .titleHeader {
      width: 100%;
      height: 4vh;
      background: url('/static/img/layout/titleHeaderBg.png');
      background-size: 100% 100%;
      display: flex;
      align-items: center;
      >img {
        height: 100%;
        margin-right: 20px;
      }
      .titleName {
        font-family: SourceHanSansCN-Bold;
        font-size: 1.5vh;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #05dbe3;
      }
    }
    .eventCount {
      width: 100%;
      height: 85%;
    }
  }
</style>
